import { EncryptionKey } from "./encryption";
import CryptoJS from 'crypto-js';

export default function decryptData(msg: string) {
    let bytes = CryptoJS.AES.decrypt(msg, EncryptionKey);
    try {
        let data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return data;
    }
    catch {
        return bytes.toString(CryptoJS.enc.Utf8);
    }
}
